export enum MarketSession {
  afterHours = 'After Hours',
  preMarket = 'PreMarket',
  regular = 'Regular',
}
